/* ============================================================
   EVENT CALENDAR — Shopify Theme Asset (JS)
   完成版 / Liquid直接渡し方式
   APIトークン不要。LiquidがShopify商品データをJSに直接渡す。

   機能：
   - タグによりドット色を切り替え
       ヴァルカナイズアカデミー → 赤ドット・PDP遷移あり
       イベント               → 青ドット・PDP遷移あり
       休業日 / 営業開始日    → オレンジドット・遷移なし・時間表示なし
   - 遷移しないタグは tagNoLink 配列で管理（Liquidから注入）
   - カレンダー右下にレジェンド表示
   - 月曜始まり・日本の祝日対応
   ============================================================ */

(function () {
  'use strict';

  // ── Config と商品データ（snippets/event-calendar.liquid から注入） ──
  const CONFIG    = window.EventCalendarConfig || {};
  const TAG_ACADEMY  = CONFIG.tagAcademy  || 'ヴァルカナイズアカデミー';
  const TAG_EVENT    = CONFIG.tagEvent    || 'イベント';
  const TAGS_NO_LINK = CONFIG.tagNoLink   || ['休業日', '営業開始日'];

  // Liquidから注入された商品データ
  // 形式: [{ title, url, startDate, endDate, dotType }, ...]
  const allEvents = (window.EventCalendarData || []).map(ev => ({
    ...ev,
    startDate: ev.startDate ? new Date(ev.startDate) : null,
    endDate:   ev.endDate   ? new Date(ev.endDate)   : null,
  })).filter(ev => ev.startDate);

  // ── 日本の祝日 ─────────────────────────────────────────────
  const JP_HOLIDAYS = {
    '2026-01-01': '元日',
    '2026-01-12': '成人の日',
    '2026-02-11': '建国記念の日',
    '2026-02-23': '天皇誕生日',
    '2026-03-20': '春分の日',
    '2026-04-29': '昭和の日',
    '2026-05-03': '憲法記念日',
    '2026-05-04': 'みどりの日',
    '2026-05-05': 'こどもの日',
    '2026-07-20': '海の日',
    '2026-08-11': '山の日',
    '2026-09-21': '敬老の日',
    '2026-09-23': '秋分の日',
    '2026-10-12': 'スポーツの日',
    '2026-11-03': '文化の日',
    '2026-11-23': '勤労感謝の日',
    '2027-01-01': '元日',
    '2027-01-11': '成人の日',
    '2027-02-11': '建国記念の日',
    '2027-02-23': '天皇誕生日',
    '2027-03-21': '春分の日',
    '2027-04-29': '昭和の日',
    '2027-05-03': '憲法記念日',
    '2027-05-04': 'みどりの日',
    '2027-05-05': 'こどもの日',
  };

  // ── State ─────────────────────────────────────────────────
  let currentYear  = new Date().getFullYear();
  let currentMonth = new Date().getMonth();

  // ── Entry ─────────────────────────────────────────────────
  function init() {
    const root = document.getElementById('event-calendar-root');
    if (!root) return;
    renderShell(root);
    renderCalendar();
  }

  // ── Shell（タイトル・ナビ・レジェンド） ───────────────────
  function renderShell(root) {
    root.innerHTML = `
      <div class="ec-wrapper">
        <div class="ec-title"><h2>EVENT SCHEDULE</h2></div>
        <div class="ec-nav">
          <button class="ec-nav-btn" id="ec-prev">&lt; Prev</button>
          <div class="ec-month-label" id="ec-month-label"></div>
          <button class="ec-nav-btn" id="ec-next">Next &gt;</button>
        </div>
        <div id="ec-calendar-body"></div>
        <div class="ec-legend">
          <span class="ec-legend-item">
            <span class="ec-event-dot ec-dot-academy"></span>：ヴァルカナイズ・アカデミー
          </span>
          <span class="ec-legend-item">
            <span class="ec-event-dot ec-dot-event"></span>：イベント
          </span>
          <span class="ec-legend-item">
            <span class="ec-event-dot ec-dot-closed"></span>：休業日・営業開始日
          </span>
        </div>
      </div>
    `;

    document.getElementById('ec-prev').addEventListener('click', () => {
      currentMonth--;
      if (currentMonth < 0) { currentMonth = 11; currentYear--; }
      renderCalendar();
    });

    document.getElementById('ec-next').addEventListener('click', () => {
      currentMonth++;
      if (currentMonth > 11) { currentMonth = 0; currentYear++; }
      renderCalendar();
    });
  }

  // ── カレンダー描画 ─────────────────────────────────────────
  function renderCalendar() {
    const monthNames = [
      'Jan.','Feb.','Mar.','Apr.','May.','Jun.',
      'Jul.','Aug.','Sep.','Oct.','Nov.','Dec.'
    ];
    document.getElementById('ec-month-label').textContent =
      `${monthNames[currentMonth]} ${currentYear}`;
    document.getElementById('ec-calendar-body').innerHTML = buildTableHTML();
  }

  // ── テーブルHTML生成 ───────────────────────────────────────
  function buildTableHTML() {
    const DAY_HEADERS = ['Mon.','Tue.','Wed.','Thu.','Fri.','Sat.','Sun.'];

    let thead = '<thead><tr>';
    DAY_HEADERS.forEach((d, i) => {
      const cls = i === 5 ? 'ec-th-sat' : i === 6 ? 'ec-th-sun' : '';
      thead += `<th class="${cls}">${d}</th>`;
    });
    thead += '</tr></thead>';

    const firstDay = new Date(currentYear, currentMonth, 1);
    const lastDay  = new Date(currentYear, currentMonth + 1, 0);
    const today    = new Date();
    const todayStr = toDateStr(today);

    let startDow = firstDay.getDay();
    startDow = startDow === 0 ? 6 : startDow - 1;

    const weeks = [];
    let week = [];

    for (let i = 0; i < startDow; i++) {
      week.push({ date: new Date(currentYear, currentMonth, 1 - (startDow - i)), otherMonth: true });
    }
    for (let d = 1; d <= lastDay.getDate(); d++) {
      week.push({ date: new Date(currentYear, currentMonth, d), otherMonth: false });
      if (week.length === 7) { weeks.push(week); week = []; }
    }
    if (week.length > 0) {
      let nextDay = 1;
      while (week.length < 7) {
        week.push({ date: new Date(currentYear, currentMonth + 1, nextDay++), otherMonth: true });
      }
      weeks.push(week);
    }

    let tbody = '<tbody>';
    weeks.forEach(w => {
      tbody += '<tr>';
      w.forEach(({ date, otherMonth }, colIdx) => {
        const dateStr   = toDateStr(date);
        const isSat     = colIdx === 5;
        const isSun     = colIdx === 6;
        const isToday   = dateStr === todayStr;
        const holiday   = JP_HOLIDAYS[dateStr];
        const isHoliday = !!holiday && !isSat && !isSun;

        const classes = ['ec-cell'];
        if (otherMonth) classes.push('ec-cell-other-month');
        if (isSat)      classes.push('ec-cell-sat');
        if (isSun)      classes.push('ec-cell-sun');
        if (isHoliday)  classes.push('ec-cell-holiday');
        if (isToday)    classes.push('ec-cell-today');

        let dayNumHTML = `<div class="ec-day-num">${date.getDate()}`;
        if (holiday) dayNumHTML += ` <span class="ec-holiday-label">${holiday}</span>`;
        dayNumHTML += '</div>';

        const dayEvents = otherMonth ? [] : getEventsForDate(dateStr);
        let eventsHTML = '<div class="ec-events">';

        dayEvents.forEach(ev => {
          const isClosed = ev.dotType === 'closed';
          const timeStr  = isClosed ? '' : formatTimeRange(ev.startDate, ev.endDate);
          const dotCls   = ev.dotType === 'academy' ? 'ec-dot-academy'
                         : ev.dotType === 'event'   ? 'ec-dot-event'
                         : ev.dotType === 'closed'  ? 'ec-dot-closed'
                         : 'ec-dot-academy';

          if (isClosed) {
            eventsHTML += `
              <div class="ec-event-closed">
                <div class="ec-event-time">
                  <span class="ec-event-dot ${dotCls}"></span>
                </div>
                <div class="ec-event-title">${escapeHtml(ev.title)}</div>
              </div>
            `;
          } else {
            eventsHTML += `
              <a href="${ev.url}" class="ec-event">
                <div class="ec-event-time">
                  <span class="ec-event-dot ${dotCls}"></span>${timeStr}
                </div>
                <div class="ec-event-title">${escapeHtml(ev.title)}</div>
              </a>
            `;
          }
        });

        eventsHTML += '</div>';
        tbody += `<td class="${classes.join(' ')}">${dayNumHTML}${eventsHTML}</td>`;
      });
      tbody += '</tr>';
    });
    tbody += '</tbody>';

    return `<table class="ec-grid">${thead}${tbody}</table>`;
  }

  // ── ユーティリティ ─────────────────────────────────────────
  function toDateStr(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function getEventsForDate(dateStr) {
    return allEvents.filter(ev => ev.startDate && toDateStr(ev.startDate) === dateStr);
  }

  function formatTimeRange(start, end) {
    const fmt = d =>
      `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
    return end ? `${fmt(start)} 〜 ${fmt(end)}` : fmt(start);
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Boot ──────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
